import React from 'react';
import Modal from '../../components/Modal/modal';

interface PendingAproveDeleteConfirmModalProps {
  visible: boolean;
  isLoading?: boolean;
  onConfirm: () => void;
  onHide: () => void;
}

const PendingAproveDeleteConfirmModal: React.FC<
  PendingAproveDeleteConfirmModalProps
> = ({ visible, isLoading = false, onConfirm, onHide }) => (
  <Modal
    visible={visible}
    title="Deseja excluir a auditoria?"
    className="pending-aprove-delete-confirm-modal"
    position="top"
    actions={[
      {
        label: 'Cancelar',
        onClick: onHide,
        buttonProps: {
          disabled: isLoading,
          className: 'pending-aprove-delete-confirm-modal-btn-cancel',
        },
      },
      {
        label: 'OK',
        onClick: onConfirm,
        buttonProps: {
          loading: isLoading,
          disabled: isLoading,
          className: 'pending-aprove-delete-confirm-modal-btn-ok',
        },
      },
    ]}
    actionsClassName="pending-aprove-delete-confirm-modal-footer"
    onHide={onHide}
  />
);

export default React.memo(PendingAproveDeleteConfirmModal);
